import React, { Fragment } from "react";

import img13 from "../../../images/service/Node Sales Service/1.png";
import img14 from "../../../images/service/Node Sales Service/2.png";
import img15 from "../../../images/service/Node Sales Service/3.png";
// Service icons
import sIcon1 from "../../../images/icon/service-icon01.svg";
import sIcon2 from "../../../images/icon/service-icon02.svg";
import sIcon3 from "../../../images/icon/service-icon03.svg";
import sIcon4 from "../../../images/icon/service-icon04.svg";
import sIcon5 from "../../../images/icon/service-icon05.svg";
import sIcon6 from "../../../images/icon/service-icon06.svg";

// Common Components
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";

import HeroSection from "../../../components/PageSection/HeroSection";
import ServiceCardsSection from "../../../components/PageSection/ServiceCardSection";
import Benefit from "../../../components/PageSection/BenefitSection";
import KeyFeaturesSection from "../../../components/PageSection/KeyFeature";
import WhyChooseUsSection from "../../../components/PageSection/WhyChooseUsSection";
import FaqSection from "../../../components/PageSection/FAQsection";
import FinalCenteredCTA from "../../../components/PageSection/FinalCTA";
import Industries from "../../../components/Industries/Industries";
import TheorySection from "../../../components/PageSection/Theory";

// =====================
// DATA
// =====================

const serviceCards = [
  {
    icon: sIcon1,
    title: "Node Sales Strategy",
    content:
      "We design customized node sale models aligned with your tokenomics, ecosystem goals, and long-term sustainability.",
  },
  {
    icon: sIcon2,
    title: "Node Sale Platform Development",
    content:
      "Launch secure and scalable node sale platforms with wallet integration, dashboards, and automation.",
  },
  {
    icon: sIcon3,
    title: "Marketing & Community Growth",
    content:
      "Drive adoption through targeted marketing campaigns, community engagement, and launch support.",
  },
];

const benefits = [
  {
    title: "Decentralized Network Growth",
    description:
      "Node sales encourage community participation and strengthen network decentralization.",
    icon: sIcon1,
  },
  {
    title: "Early Ecosystem Funding",
    description:
      "Generate sustainable funding without relying solely on traditional token sales.",
    icon: sIcon2,
  },
  {
    title: "Community Ownership",
    description:
      "Node operators become long-term stakeholders in your blockchain ecosystem.",
    icon: sIcon3,
  },
  {
    title: "Scalable Infrastructure",
    description:
      "Distributed node operators improve performance, reliability, and network uptime.",
    icon: sIcon4,
  },
];

const faqs = [
  {
    q: "What is a node sale?",
    a: "A node sale allows users to purchase and operate network nodes that support blockchain infrastructure and earn rewards.",
  },
  {
    q: "How do node sales benefit blockchain projects?",
    a: "Node sales help decentralize the network, raise funds, and incentivize long-term community participation.",
  },
  {
    q: "Do you provide end-to-end node sale solutions?",
    a: "Yes. We handle strategy, platform development, launch, and post-sale support.",
  },
  {
    q: "Can node sales integrate with existing blockchains?",
    a: "Absolutely. Node sale systems can be integrated with existing Layer 1 and Layer 2 blockchains.",
  },
];

// =====================
// PAGE COMPONENT
// =====================

export default function NodeSalesService() {
  return (
    <Fragment>
      <Header />

      <PageTitle
        pageTitle="Node Sales Service"
        pagesub="Build, scale, and decentralize your blockchain network"
      />

      {/* HERO SECTION */}
      <HeroSection
        title={
          <>
            Power Your Network with{" "}
            <span className="gradient-text">Node Sales</span>
          </>
        }
        subtitle={`Launch secure and scalable node sales to grow your blockchain
ecosystem, strengthen decentralization, and empower your community.`}
        buttonText="Book Consultation"
        buttonLink="/contact"
        image={img13}
        imageAlt="Node Sales Service"
      />

      {/* ================= THEORY 1 ================= */}
      <TheorySection
        title="What Are Node Sales?"
        image={img14}
        paragraphs={[
          "Node sales enable blockchain projects to distribute network nodes to community members who actively participate in securing and maintaining the ecosystem.",
          "By allowing users to run nodes, projects achieve better decentralization, performance, and long-term sustainability.",
        ]}
      />

      {/* SERVICES */}
      <ServiceCardsSection
        title="Our Node Sales Services"
        cards={serviceCards}
      />

      {/* ================= THEORY 2 ================= */}
      <TheorySection
        title="Why Node Sales Matter for Blockchain Growth"
        image={img15}
        paragraphs={[
          "Centralized infrastructure creates bottlenecks, security risks, and single points of failure.",
          "Node sales distribute responsibility across participants, creating a resilient and community-driven blockchain network.",
        ]}
      />

      {/* BENEFITS */}
      <Benefit
        title="Benefits of Node Sales"
        benefits={benefits}
      />

      {/* KEY FEATURES */}
      <KeyFeaturesSection
        title="Key Features of Our Node Sales Solutions"
        subtitle="Designed for scalability, security, and ecosystem growth"
        features={[
          {
            icon: sIcon1,
            title: "Secure Node Allocation",
            description:
              "Fair and transparent node distribution mechanisms.",
          },
          {
            icon: sIcon2,
            title: "Integrated Dashboards",
            description:
              "Real-time monitoring of node performance and rewards.",
          },
          {
            icon: sIcon3,
            title: "Tokenized Incentives",
            description:
              "Reward node operators through transparent token models.",
          },
          {
            icon: sIcon4,
            title: "Smart Contract Automation",
            description:
              "Automated node provisioning and reward distribution.",
          },
          {
            icon: sIcon5,
            title: "Scalable Architecture",
            description:
              "Support thousands of nodes without performance degradation.",
          },
          {
            icon: sIcon6,
            title: "Post-Launch Support",
            description:
              "Ongoing optimization, upgrades, and maintenance.",
          },
        ]}
      />

      <Industries />

      {/* WHY CHOOSE US */}
      <WhyChooseUsSection
        items={[
          "Proven experience in Web3 infrastructure projects",
          "Strategic approach to node economics",
          "End-to-end launch and support services",
        ]}
      />

      {/* FAQ */}
      <FaqSection faqs={faqs} />

      {/* FINAL CTA */}
      <FinalCenteredCTA />

      <Footer />
      <Scrollbar />
    </Fragment>
  );
}
